(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cookie-consent"]) return;
  try {
    
  (() => {
    const STORAGE_KEY = 'cookie-consent'
    const CONSENT_EVENT = 'cookie-consent-updated'

    const root = document.querySelector('[data-cookie-consent]')
    if (!root) return

    const banner = root.querySelector('[data-cookie-banner]')
    const preferences = root.querySelector('[data-cookie-preferences]')
    const manageBtn = root.querySelector('[data-cookie-manage]')

    const delay = parseInt(root.dataset.delay) || 0
    const expireDays = parseInt(root.dataset.expireDays) || 365
    const CATEGORIES = (root.dataset.categories || 'necessary').split(',')

    function getConsent() {
      try {
        const raw = localStorage.getItem(STORAGE_KEY)
        return raw ? JSON.parse(raw) : null
      } catch {
        return null
      }
    }

    function setConsent(data) {
      data.timestamp = Date.now()
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(data))
      } catch {
        // Storage full or unavailable
      }
      window.dispatchEvent(new CustomEvent(CONSENT_EVENT, { detail: data }))
    }

    function hasExpired(consent) {
      if (!consent || !consent.timestamp) return true
      const age = (Date.now() - consent.timestamp) / (1000 * 60 * 60 * 24)
      return age > expireDays
    }

    function buildConsent(categoryValues) {
      const consent = { consented: true }
      for (const cat of CATEGORIES) {
        consent[cat] = categoryValues[cat] ?? (cat === 'necessary' ? true : false)
      }
      consent.necessary = true
      return consent
    }

    function hideBanner() {
      if (banner) banner.style.display = 'none'
    }

    function showBanner() {
      if (banner) banner.style.display = ''
    }

    function hidePreferences() {
      if (preferences) preferences.classList.add('hidden')
    }

    function showPreferences() {
      if (preferences) {
        preferences.classList.remove('hidden')
        const firstCheckbox = preferences.querySelector('input[type="checkbox"]')
        if (firstCheckbox) firstCheckbox.focus()
      }
    }

    function showManageButton() {
      if (manageBtn) manageBtn.style.display = ''
    }

    function hideManageButton() {
      if (manageBtn) manageBtn.style.display = 'none'
    }

    function syncPreferencesFromConsent(consent) {
      if (!consent || !preferences) return
      const checkboxes = preferences.querySelectorAll('[data-cookie-category]')
      checkboxes.forEach((cb) => {
        cb.checked = consent[cb.dataset.cookieCategory] === true
      })
    }

    function acceptAll() {
      const consent = {}
      for (const cat of CATEGORIES) consent[cat] = true
      consent.consented = true
      setConsent(consent)
      hideBanner()
      hidePreferences()
      showManageButton()
    }

    function rejectAll() {
      const consent = {}
      for (const cat of CATEGORIES) consent[cat] = cat === 'necessary'
      consent.consented = true
      setConsent(consent)
      hideBanner()
      hidePreferences()
      showManageButton()
    }

    function savePreferences() {
      if (!preferences) return
      const consent = { consented: true, necessary: true }
      const checkboxes = preferences.querySelectorAll('[data-cookie-category]')
      checkboxes.forEach((cb) => {
        consent[cb.dataset.cookieCategory] = cb.checked
      })
      setConsent(consent)
      hideBanner()
      hidePreferences()
      showManageButton()
    }

    function handleClick(e) {
      const actionEl = e.target.closest('[data-cookie-action]')
      if (!actionEl) return

      const action = actionEl.dataset.cookieAction

      switch (action) {
        case 'accept':
          acceptAll()
          break
        case 'reject':
          rejectAll()
          break
        case 'preferences':
          hideBanner()
          showPreferences()
          syncPreferencesFromConsent(getConsent())
          break
        case 'save':
          savePreferences()
          break
        case 'close-preferences':
          hidePreferences()
          showBanner()
          break
        case 'manage':
          showPreferences()
          syncPreferencesFromConsent(getConsent())
          break
      }
    }

    function init() {
      root.addEventListener('click', handleClick)

      const existing = getConsent()

      if (existing && existing.consented && !hasExpired(existing)) {
        hideBanner()
        hidePreferences()
        showManageButton()
        window.dispatchEvent(new CustomEvent(CONSENT_EVENT, { detail: existing }))
        return
      }

      if (existing && existing.consented && hasExpired(existing)) {
        localStorage.removeItem(STORAGE_KEY)
      }

      if (delay > 0) {
        hideBanner()
        setTimeout(() => {
          showBanner()
        }, delay)
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init)
    } else {
      init()
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches
    if (prefersReducedMotion) return

    const PARALLAX_SELECTOR = '[data-hero-parallax]'
    let isTicking = false
    const PARALLAX_MULTIPLIER = 2.25

    const update = () => {
      const elements = document.querySelectorAll(PARALLAX_SELECTOR)
      if (!elements.length) return

      const viewportH = window.innerHeight || document.documentElement.clientHeight || 0

      elements.forEach((el) => {
        const rect = el.getBoundingClientRect()
        const strength = parseFloat(getComputedStyle(el).getPropertyValue('--hero-parallax-strength')) || 0
        if (!strength || !viewportH) return

        const elCenter = rect.top + rect.height / 2
        const viewportCenter = viewportH / 2
        const distance = (elCenter - viewportCenter) / viewportH
        let offsetPx = distance * strength * -1 * PARALLAX_MULTIPLIER
        offsetPx = Math.max(-strength, Math.min(strength, offsetPx))

        el.style.setProperty('--hero-parallax-offset', `${offsetPx.toFixed(2)}px`)
      })
    }

    const requestTick = () => {
      if (isTicking) return
      isTicking = true
      window.requestAnimationFrame(() => {
        update()
        isTicking = false
      })
    }

    const init = () => {
      update()
      window.addEventListener('scroll', requestTick, { passive: true })
      window.addEventListener('resize', requestTick)
      document.addEventListener('shopify:section:load', requestTick)
      setTimeout(requestTick, 120)
      setTimeout(requestTick, 600)
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init)
    } else {
      init()
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tabbed-feature-showcase"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.__tfsFeatureShowcaseBound) return
    window.__tfsFeatureShowcaseBound = true

    const ROOT_SELECTOR = '[data-tfs-tabs]'
    const TAB_SELECTOR = '[data-tfs-tab]'
    const PANEL_SELECTOR = '[data-tfs-panel]'
    const STASH_SELECTOR = '[data-tfs-stash]'
    const ITEM_SELECTOR = '[data-tfs-item]'
    const TABLIST_SELECTOR = '[data-tfs-tablist]'
    const PANELS_WRAP_SELECTOR = '[data-tfs-panels]'
    const EMPTY_SELECTOR = '[data-tfs-empty]'

    const ACTIVE_TAB_CLASSES = ['bg-foreground', 'text-background', 'border-border', 'shadow-sm']

    const hydrateRoot = (root) => {
      if (root.dataset.tfsHydrated === 'true') return

      const tablist = root.querySelector(TABLIST_SELECTOR)
      const panelsWrap = root.querySelector(PANELS_WRAP_SELECTOR)
      const stash = root.querySelector(STASH_SELECTOR)
      if (!tablist || !panelsWrap || !stash) return

      const items = Array.from(stash.querySelectorAll(ITEM_SELECTOR))
      if (!items.length) return

      items.slice(0, 6).forEach((item) => {
        const tab = item.querySelector('[data-tfs-tab-item]')
        const panel = item.querySelector('[data-tfs-panel-item]')
        if (tab) tablist.appendChild(tab)
        if (panel) panelsWrap.appendChild(panel)
      })

      items.slice(6).forEach((item) => item.remove())

      stash.remove()
      root.dataset.tfsHydrated = 'true'
    }

    const setActive = (root, nextTab, opts = {}) => {
      const { focus } = { focus: false, ...opts }
      if (!root || !nextTab) return

      const tabs = Array.from(root.querySelectorAll(TAB_SELECTOR))
      const panels = Array.from(root.querySelectorAll(PANEL_SELECTOR))

      const nextPanelId = nextTab.getAttribute('aria-controls') || nextTab.dataset.tfsPanel

      tabs.forEach((tab) => {
        const isActive = tab === nextTab

        tab.setAttribute('aria-selected', isActive ? 'true' : 'false')
        tab.tabIndex = isActive ? 0 : -1

        if (isActive) tab.classList.add(...ACTIVE_TAB_CLASSES)
        else tab.classList.remove(...ACTIVE_TAB_CLASSES)

        const indicator = tab.querySelector('[data-tfs-indicator]')
        if (indicator) {
          indicator.classList.toggle('opacity-100', isActive)
          indicator.classList.toggle('opacity-0', !isActive)
        }

        const arrow = tab.querySelector('[data-tfs-arrow]')
        if (arrow) {
          arrow.classList.toggle('opacity-100', isActive)
          arrow.classList.toggle('opacity-0', !isActive)
        }
      })

      panels.forEach((panel) => {
        panel.hidden = panel.id !== nextPanelId
      })

      if (focus) nextTab.focus({ preventScroll: true })
    }

    const initRoot = (root) => {
      if (!root) return
      if (root.dataset.tfsInitialized === 'true') return

      hydrateRoot(root)

      const tabs = Array.from(root.querySelectorAll(TAB_SELECTOR))
      if (!tabs.length) return

      const empty = root.querySelector(EMPTY_SELECTOR)
      if (empty) empty.hidden = true

      root.dataset.tfsInitialized = 'true'

      const selected = tabs.find((t) => t.getAttribute('aria-selected') === 'true') || tabs[0]
      setActive(root, selected)

      tabs.forEach((tab) => {
        tab.addEventListener('click', () => setActive(root, tab))

        tab.addEventListener('keydown', (e) => {
          const key = e.key
          const isNext = key === 'ArrowDown' || key === 'ArrowRight'
          const isPrev = key === 'ArrowUp' || key === 'ArrowLeft'
          const isHome = key === 'Home'
          const isEnd = key === 'End'
          if (!isNext && !isPrev && !isHome && !isEnd) return

          e.preventDefault()

          const idx = tabs.indexOf(tab)
          let nextIdx = idx

          if (isHome) nextIdx = 0
          else if (isEnd) nextIdx = tabs.length - 1
          else if (isNext) nextIdx = (idx + 1) % tabs.length
          else if (isPrev) nextIdx = (idx - 1 + tabs.length) % tabs.length

          setActive(root, tabs[nextIdx], { focus: true })
        })
      })
    }

    const initAll = () => {
      document.querySelectorAll(ROOT_SELECTOR).forEach(initRoot)
    }

    const onBlockSelect = (e) => {
      const detail = e.detail || {}
      const sectionId = detail.sectionId
      const blockId = detail.blockId
      if (!sectionId || !blockId) return

      const roots = document.querySelectorAll(`${ROOT_SELECTOR}[data-section-id="${sectionId}"]`)
      if (!roots.length) return

      roots.forEach((root) => {
        initRoot(root)
        const tab = root.querySelector(`${TAB_SELECTOR}[data-tfs-block-id="${blockId}"]`)
        if (tab) setActive(root, tab)
      })
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll, { once: true })
    } else {
      initAll()
    }

    document.addEventListener('shopify:section:load', initAll)
    document.addEventListener('shopify:block:select', onBlockSelect)
  })()

  } catch(e) { console.error(e); }
})();
})();
